import 'slick-carousel/slick/slick.min.js';

$(function () {

  $(".about-sme-container").slick({

    dots: true,
    autoplay: true,
    autoplaySpeed: 5000,
    speed: 500,
    infinite: true,
    centerMode: true,
    centerPadding: '200px',
    responsive: [
      {
        breakpoint: 768,
        settings: {
          centerMode: false,
        }
      },
      {
        breakpoint: 480,
        settings: {
          centerMode: false,
        }
      }
    ]
  });

  var partnerSlickConfig = {
    dots: false,
    autoplay: false,
    slidesToShow: 3,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2
        }
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1
        }
      }
    ]
  };

  $(window).on('resize orientationchange', function () {
    $(".about-partner-container").slick('resize');
  });

  $(".about-partner-container").slick(partnerSlickConfig);

});



// WEBPACK FOOTER //
// ./assets/js/about.js